module.exports = __webpack_public_path__ + "static/media/free-gift-stack.6d066514.png";